export default function Footer() {
  return (
    <footer className=" text-white text-center">
      <p>&copy;2024</p>
    </footer>
  );
}
